import React, { useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { ModalContext } from "../../contexts/modalContext";
import '../../assets/styles/modal.scss';
import { Colors } from "../../constants";

const Modal = () => {
  let { modalTitle, modalContent, handleModal, modal, modalSubmitCallback, textButton, customColor, info } = useContext(ModalContext);
  
  const [ buttonBgColorPrimary, setButtonBgColorPrimary ] = useState(`#${Colors.primaryColor}`);
  const [ buttonFontColorPrimary, setButtonFontColorPrimary ] = useState(`#${Colors.white}`);
  const [ buttonBgColorSecondary, setButtonBgColorSecondary ] = useState(`#${Colors.secondaryColor}`);
  const [ buttonFontColorSecondary, setButtonFontColorSecondary ] = useState(`#${Colors.primaryColor}`);

  useEffect(() => {
    setButtonBgColorPrimary(`${customColor}`);
    setButtonBgColorSecondary(`${customColor}10`);
    setButtonFontColorSecondary(`${customColor}`);
  }, [customColor]);

  const buttonPrimaryHover = () => {
    setButtonBgColorPrimary(`${customColor}10`);
    setButtonFontColorPrimary(`${customColor}`);
  };

  const buttonPrimaryOut = () => {
    setButtonBgColorPrimary(`${customColor}`);
    setButtonFontColorPrimary(`#${Colors.white}`);
  };

  const buttonSecondaryHover = () => {
    setButtonBgColorSecondary(`#${Colors.white}`);
    setButtonFontColorSecondary(`${customColor}`);
  };

  const buttonSecondaryOut = () => {
    setButtonBgColorSecondary(`${customColor}10`);
    setButtonFontColorSecondary(`${customColor}`);
  };

  if(!modal) return null;

  return ReactDOM.createPortal(
    <>
      <div className="modal-overlay"/>
        <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
          <div className="modal">
            
            
            <div className={`modal-header modal-padding ${!info && 'no-border'}`}>
              {modalTitle && (
                <div className="modal-title">
                  { modalTitle }
                </div>
              )}
              
              <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={() => handleModal()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className={`modal-content-overlay modal-padding ${ !info && 'no-border' }`}>
                { modalContent }
            </div>

            <div className={`modal-footer ${ !info && 'no-border'}`}>
              { textButton?.cancel && (
                <button 
                  className="button button-default pull-right" 
                  style={{ backgroundColor: buttonBgColorSecondary, color: buttonFontColorSecondary, borderColor: buttonFontColorSecondary }}
                  onMouseOver={() => buttonSecondaryHover()}
                  onMouseOut={() => buttonSecondaryOut()}
                  type="button" onClick={() => handleModal()}>
                    { textButton ? textButton['cancel'] : 'Cancel' }
                </button>
              )}
              <button 
                className="button button-submit pull-right" 
                style={{ backgroundColor: buttonBgColorPrimary, color: buttonFontColorPrimary, borderColor: buttonBgColorPrimary }}
                onMouseOver={() => buttonPrimaryHover()}
                onMouseOut={() => buttonPrimaryOut()}
                type="button" onClick={() => modalSubmitCallback()}>
                  { textButton ? textButton['submit'] : 'Submit' }
                </button>
            </div>
          </div>
        </div>
    </>
    ,document.querySelector("#modal-root")
  );
};

export default Modal;